import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { BasketSummaryDetailsStyled } from '../BasketSummaryDetailsStyled';

export const BasketSummaryDetailsAP = styled(BasketSummaryDetailsStyled)`
    background: ${({ theme }) => theme.colors.grey8};

    .promoCodeSection {
        .promoCode__input_label_success,
        .promoCode__input_label_error {
            @media (min-width: ${breakpoints.md}px) {
                background: ${({ theme }) => theme.colors.grey8};
            }
        }
    }

    .continueSection {
        background: ${({ theme }) => theme.colors.accordionSecondaryBg};
    }
`;
